<ng-container *transloco="let t; read: 'personsVacation'">
  <crm-grid *ngIf="vacationStatus === VacationStatus.started; else editForm">
    <crm-grid-col [cols]="3">
      <crm-row>
        <header>{{ t('onVacation') }}</header>
        <main>
          {{
            t('dateInterval', {
              startDate: (currentOrFutureVacation.startsAt | date : 'shortDate'),
              endDate: (currentOrFutureVacation.endsAt | date : 'shortDate')
            })
          }}
        </main>
      </crm-row>
    </crm-grid-col>
    <crm-grid-col [cols]="3">
      <button mat-button color="primary" type="button" (click)="return()">{{ t('resume') }}</button>
    </crm-grid-col>
  </crm-grid>

  <ng-template #editForm>
    <crm-grid>
      <crm-grid-col [cols]="3">
        <crm-form-field-date-interval [parentFormGroup]="form" [field]="datesField"></crm-form-field-date-interval>
        <mat-error *ngIf="form.getError('vacationDuration', 'dates')" class="mb-5">
          <span>{{ t('vacationDuration') }}</span>
        </mat-error>
        <mat-error *ngIf="form.getError('schoolBreakMinDuration')" class="mb-5">
          <span>{{ t('schoolBreakMinDuration') }}</span>
        </mat-error>
        <mat-error *ngIf="form.getError('schoolBreakOverlapsSummer')" class="mb-5">
          <span>{{ t('schoolBreakOverlapsSummer') }}</span>
        </mat-error>
      </crm-grid-col>
      <crm-grid-col [cols]="5">
        <ng-container *ngIf="vacationStatus === VacationStatus.notPlanned">
          <button mat-button color="primary" type="button" (click)="send()" [disabled]="form.invalid">
            {{ t('toSchedule') }}
          </button>
        </ng-container>

        <ng-container *ngIf="vacationStatus === VacationStatus.scheduled">
          <button mat-button color="primary" type="button" (click)="change()" [disabled]="form.invalid">
            {{ t('changeDates') }}
          </button>
          <button mat-button color="warn" type="button" (click)="cancel()">{{ t('cancel') }}</button>
        </ng-container>
      </crm-grid-col>
      <crm-grid-col [cols]="12">
        <ng-container>
          <crm-form-field-radio-button
            [parentFormGroup]="form"
            [field]="reason"
            [column]="true"
            class="reasons"
          ></crm-form-field-radio-button>
        </ng-container>
      </crm-grid-col>
    </crm-grid>
  </ng-template>
</ng-container>
